import React, { useState, useEffect } from "react";
import "./Home.css";

function EditFormModal({ show, onClose, formData, onFormUpdated }) {
  const [formName, setFormName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyImageUrl, setCompanyImageUrl] = useState("");
  const [companyImage, setCompanyImage] = useState(null);
  const [policyText, setPolicyText] = useState(""); // New State
  const [policyLink, setPolicyLink] = useState(""); // New State

  useEffect(() => {
    if (formData) {
      setFormName(formData.name);
      setCompanyName(formData.company_name);
      setCompanyImageUrl(formData.company_image || "");
      setPolicyText(formData.policy_text || ""); // Load existing policy text
      setPolicyLink(formData.policy_link || ""); // Load existing policy link
    }
  }, [formData]);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setCompanyImage(file);

    const formDataUpload = new FormData();
    formDataUpload.append("image", file);

    try {
      const res = await fetch("https://leadbankapi.gensparc.com/api/upload", {
        method: "POST",
        body: formDataUpload,
      });
      const data = await res.json();
      setCompanyImageUrl(data.imageUrl);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formName.trim() || !companyName.trim()) {
      alert("Please enter both form name and company name.");
      return;
    }
    try {
      const res = await fetch(`https://leadbankapi.gensparc.com/api/forms/home/${formData.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formName,
          company_name: companyName,
          company_image: companyImageUrl,
          policy_text: policyText, // Send updated policy text
          policy_link: policyLink, // Send updated policy link
        }),
      });
      if (res.ok) {
        onFormUpdated();
      } else {
        const data = await res.json();
        alert(data.message);
      }
    } catch (error) {
      console.error("Error updating form:", error);
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" id="edit-form-modal">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Edit Form</h2>
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Form Name:</label>
              <input
                type="text"
                value={formName}
                onChange={(e) => setFormName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Company Name:</label>
              <input
                type="text"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Company Image:</label>
              <input type="file" accept="image/*" onChange={handleImageUpload} />
              {companyImageUrl && (
                <img
                  src={`https://leadbankapi.gensparc.com${companyImageUrl}`}
                  alt="Company Preview"
                  className="uploaded-preview"
                />
              )}
            </div>

            {/* Policy Text Field */}
            <div className="form-group">
              <label>Policy Text:</label>
              <textarea
                value={policyText}
                onChange={(e) => setPolicyText(e.target.value)}
                required
              ></textarea>
            </div>

            {/* Policy Link Field */}
            <div className="form-group">
              <label>Policy Link:</label>
              <input
                type="url"
                value={policyLink}
                onChange={(e) => setPolicyLink(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn submit">
              Update Form
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditFormModal;
